import { useEffect, useRef } from 'react';
import {
  ControllerRenderProps,
  UseFormReturn,
  useFormContext,
} from 'react-hook-form';
import { useEffectOnce } from 'usehooks-ts';

/**
 * Hook con un effect che viene eseguito quando il campo
 * viene disabilitato.
 */
export function useOnFieldDisabled(
  field: ControllerRenderProps<any, string>,
  enabled: boolean | undefined,
  callback: (methods: UseFormReturn, fieldName: string) => void,
) {
  // Ref utilizzata per evitare il rerender loop
  const enabledRef = useRef(enabled);

  const methods = useFormContext();

  useEffectOnce(() => {
    if (!enabled) {
      callback(methods, field.name);
    }
  });

  // Questo useEffect serve per resettare il valore del campo
  // quando viene disabilitato
  useEffect(() => {
    // Se il valore di enabled non cambia, non fare nulla
    if (enabledRef.current === enabled) return;

    enabledRef.current = enabled;

    // Se il valore è cambiato e il campo è abilitato,
    // registra l'informazione e non fare nulla
    if (enabled !== false) return;

    callback(methods, field.name);
  }, [field, enabled, methods, callback]);
}
